import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import AppProvider from "./providers/AppProvider";
const startPromise = import.meta.env.VITE_ENABLE_MSW === "true" && import.meta.env.VITE_USE_MOCK_API === "true" ? import("./mocks/browser").then(({ worker })=>worker.start({
        onUnhandledRequest: (req, print)=>{
            // Bypass MSW for LocalStack requests (S3, DynamoDB, etc.)
            if (req.url.includes("localhost:4566")) {
                return;
            }
            print.warning();
        }
    })) : Promise.resolve(true);
void startPromise.then(()=>{
    ReactDOM.createRoot(document.getElementById("root")).render(/*#__PURE__*/ _jsx(StrictMode, {
        children: /*#__PURE__*/ _jsx(AppProvider, {})
    }));
});
